// extracted by mini-css-extract-plugin
export default {"month":"CalendarMonth_month__KzsRd","header":"CalendarMonth_header__Cpa9h","weekdays":"CalendarMonth_weekdays__8E5DD","days":"CalendarMonth_days__H5Rhr"};